import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AboutPage } from '../about/about';
import { UserModel } from './../../models/user/user';
import { AuthProvider } from './../../providers/auth/auth';
import { ConfigurationRolePage } from './configuration-role/configuration-role';
import { ConfigurationUnitPage } from './configuration-unit/configuration-unit';
import { ConfigurationUserPage } from './configuration-user/configuration-user';

@IonicPage()
@Component({
  selector: 'page-configuration',
  templateUrl: 'configuration.html',
})
export class ConfigurationPage {
  constructor(public navCtrl: NavController, public navParams: NavParams, public authPrvdr: AuthProvider) {}

  currentUser: UserModel;
  configMenus: any = [];

  ionViewDidEnter() {
    this.checkMenuACess();
  }

  checkMenuACess() {
    this.configMenus['ROLES'] = false;
    this.configMenus['USERS'] = false;
    this.configMenus['SETTINGS'] = false;
    this.authPrvdr.authUser.subscribe((jwt) => {
      if (jwt) {
        this.authPrvdr.userData.subscribe((res) => {
          this.currentUser = res;
          if (this.currentUser !== null) {
            this.currentUser.role.menus.forEach((el) => {
              if (el === '5b5497102262a235f8a01271') {
                //ROLES
                this.configMenus['ROLES'] = true;
              }
              if (el === '5b54971c2262a235f8a01272') {
                //USERS
                this.configMenus['USERS'] = true;
              }
              if (el === '5fc0ba721d3f7946d022ad24') {
                //MPP UNIT
                this.configMenus['MPP UNIT'] = true;
              }

              if (el === '61bd86b0207b0000ec004203') {
                // SETTINGS
                this.configMenus['SETTINGS'] = true;
              }
            });
          }
        });
      }
    });
  }

  onOpenRole() {
    this.navCtrl.push(ConfigurationRolePage);
  }

  onOpenUser() {
    this.navCtrl.push(ConfigurationUserPage);
  }

  onOpenUnit() {
    this.navCtrl.push(ConfigurationUnitPage);
  }

  onOpenAbout() {
    this.navCtrl.push(AboutPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration.ts